// extracted by mini-css-extract-plugin
export default {"section":"Stats_section__h7uFV","container":"Stats_container__1w+Jh","grid":"Stats_grid__Gb0s1","item":"Stats_item__hLiH+","value":"Stats_value__dd7Ip","label":"Stats_label__41Sut"};